// hooks/useGoogleAdsConversion.ts
import { useCallback } from 'react';
import { GOOGLE_ADS_CONFIG, type ConversionResult } from '@/constants/googleAds';

export const useGoogleAdsConversion = () => {
  const trackConversion = useCallback((url?: string): ConversionResult => {
    // Simple client-side check
    if (typeof window === 'undefined') {
    //   console.log('Server side, skipping tracking');
      return {
        success: false,
        method: 'failed',
        message: 'Server side rendering - no tracking available'
      };
    }

    // console.log('Attempting to track conversion...');

    // Check if conversion function exists
    if (window.gtag_report_conversion) {
    //   console.log('✅ Using gtag_report_conversion');
      const result = window.gtag_report_conversion(url);
      return {
        success: result,
        method: 'gtag_report_conversion',
        message: 'Used gtag_report_conversion function'
      };
    }

    // Fallback: use gtag directly
    if (window.gtag) {
    //   console.log('⚠️ Using gtag fallback');
      window.gtag('event', 'conversion', {
        send_to: GOOGLE_ADS_CONFIG.ADS_SEND_TO,
        event_callback: function(): void {
          if (url) {
            window.location.href = url;
          }
        }
      });
      return {
        success: true,
        method: 'gtag_fallback',
        message: 'Used gtag event with callback'
      };
    }
    
    // Last resort: direct redirect
    // console.warn('❌ No tracking available, redirecting directly');
    if (url) {
      window.location.href = url;
    }
    return {
      success: false,
      method: 'direct_redirect',
      message: 'No tracking available - direct redirect only'
    };
  }, []);

  return { trackConversion };
};